import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-neutral-200" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22div4molhl5j">
        <div className="text-center mb-16" data-id="element-22" data-mp="1ydi8ierce3ne">
          <p className="text-red-700 font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yet8s4lkwt9r">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-neutral-900" data-id="element-24" data-mp="15pw10vezuev9">
            <span className="text-red-700" data-id="element-25" data-mp="1jhamra0acu60">5</span> EXCLUSIVE FIRE SERVICE INSTRUCTOR BONUSES
          </h2>
          <p className="text-lg text-neutral-800/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1epixr3ws2whz">
            The six main volumes deliver your complete visual training atlas. And the five
            additional bonuses give you practical written resources to support lesson planning,
            classroom discussions, student evaluations and training reviews.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="29q8o6j3p8vg2">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-neutral-200 rounded-2xl p-8 shadow-sm shadow-neutral-900/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="2eotjq580aqy6" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-neutral-900 text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="25qht43753t5q">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-red-50 border border-neutral-300 rounded-full flex items-center justify-center text-red-700 mb-4" data-id="element-30" data-mp="3c8whaob47461">
                <Gift size={24} data-id="element-31" data-mp="1h2lzkzcmp3ss" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-neutral-900" data-id="element-32" data-mp="1h588p3f63rd4">{bonus.title}</h3>
              <p className="text-red-700 text-sm font-semibold mb-4 border-l-4 border-red-700 pl-4" data-id="element-33" data-mp="1q43ewfi7p1gf">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-neutral-800 text-sm mb-4 leading-relaxed" data-id="element-34" data-mp="1m0dwy8w1li4d">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-35" data-mp="tf43irmbzjk0">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-36" data-mp="1760u6cwp5qof">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-37" data-mp="amtjcezgiab8">
                        <CheckCircle2 size={16} className="text-red-700 shrink-0 mt-0.5" data-id="element-38" data-mp="j4sgdl2jsoq" />
                        <span className="text-neutral-800 text-sm" data-id="element-39" data-mp="5aczx42u93z9">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-neutral-900 font-semibold text-sm mb-3" data-id="element-40" data-mp="3rnlbp4a3thg7">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-41" data-mp="o98uwhmitme5">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-neutral-900 font-semibold text-sm bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-2" data-id="element-42" data-mp="9bggxtwmh622">
                        {bullet}
                      </li>)}
                  </ul>
                </>}

              <div className="mt-auto space-y-3" data-id="element-43" data-mp="3f8ewt7ol7czh">
                {bonus.system && <div data-id="element-44" data-mp="3agwv2heqp8dg">
                    <p className="text-neutral-900 font-semibold text-sm mb-2" data-id="element-45" data-mp="3agofuiv59qz3">{bonus.systemLabel}</p>
                    <p className="text-neutral-900 font-bold text-xs sm:text-sm tracking-wide bg-red-50 border-l-4 border-red-700 rounded-lg px-3 py-2" data-id="element-46" data-mp="35j52dl69ti87">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-neutral-50 border border-neutral-200 border-l-4 border-l-red-700 rounded-xl p-4" data-id="element-47" data-mp="3t8za5obqggll">
                    <span className="text-neutral-900 font-bold block mb-1" data-id="element-48" data-mp="3o707yhrqbpq8">RESULT</span>
                    <p className="text-neutral-800 text-sm" data-id="element-49" data-mp="3j98h7r2tm9nm">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-neutral-200" data-id="element-50" data-mp="27uuw2tzgc8ba">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-neutral-900 font-extrabold text-base tracking-wide' : 'text-neutral-900 font-semibold text-sm italic'} data-id="element-51" data-mp="ndvhh3f87u1r" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}